// removed by extract-text-webpack-plugin
module.exports = {"icon":"JTXlL","iconWrapper":"_1arls","iconClose":"_1CEPD JTXlL","iconCloseWrapper":"_3QFLu _1arls","iconPrev":"_2syCw JTXlL","iconNext":"_1_GiI JTXlL"};